import axiosPost from '../axiosPost';
import { AxiosPostBody } from '../../../types/AxiosPost';
import { MerchantCobroType, UserCredentialsType } from '../../../types/types';

type Args = UserCredentialsType & {
    desde: string
    hasta: string
    estado: string | null
    medioDePago: string | null
    merchantCajaId: number | null
}

export const merchantCobroGet = async (arg: Args) => {
    const body: AxiosPostBody = {
        "service": "MerchantCobroGet",
        "params": {
            "merchantCobroMerchantId": null,
            "merchantCobroEstado": arg.estado,
            "posTransaccionMetodoPago": arg.medioDePago,
            "merchantCobroMerchantCajaId": Number(arg.merchantCajaId),
            "fechaDesde": arg.desde,
            "fechaHasta": arg.hasta
        }
    };

    const result = await axiosPost<MerchantCobroType>('Y', body, arg);
    return result
}